import CityPageTemplate from "../city-template/CityPageTemplate";
import { newportConfig } from "./data";

export default function NewportPage() {
  return <CityPageTemplate config={newportConfig} />;
}